import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import { Box, BoxTitle, Content, ContentTitle, StakeInput } from "../baseItems";
import Base from "./base";

export default class CoinsPaid extends Base {
	componentDidUpdate() {
		const { selectedCurrency, banks } = this.state;
		if (selectedCurrency && !banks) {
			const { method } = this.props;
			const methodType = method.split("CoinsPaid-")[1]?.toLowerCase();
		}
	}

	getStep1(translate) {
		const { method } = this.props;
		const {
			stake,
			selectedCurrency,
			crypto_currency,
			crypto_payway,
			doc_type,
			banks,
			cards,
			bank_id,
			bank_code,
			account_type,
			card,
		} = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<Fragment>
					<FormItem onRegister={() => this.registerField({ name: "address" })}>
						<Box>
							<BoxTitle>{translate("address")}</BoxTitle>
							<StakeInput
								placeholder="...................."
								onChange={this.onEnterValue.bind(this, "address")}
							/>
						</Box>
					</FormItem>
					{method === "CoinsPaid-XRP" && (
						<Fragment>
							<FormItem onRegister={() => this.registerField({ name: "tag" })}>
								<Box>
									<BoxTitle>{translate("TAG")}</BoxTitle>
									<StakeInput
										placeholder="tag"
										onChange={this.onEnterValue.bind(this, "tag")}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}
				</Fragment>
			</Content>
		);
	}

	makeExternalPayment() {
		const { method } = this.props;
		const { stake, address, selectedCurrency, tag } = this.state;
		let withdrawData = {
			targetCurrency: method.split("CoinsPaid-")[1],
			type: "CoinsPaid",
			username: getUser().username,
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			address,
			tag,
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
